module.exports = __webpack_public_path__ + "assets/img/fuguoing4.d3ae9b93.png";